export const SEARCH_COMPANIES = "SEARCH_COMPANIES";
export const SEARCH_COMPANIES_START = "SEARCH_COMPANIES_START";
export const SEARCH_COMPANIES_FAILED = "SEARCH_COMPANIES_FAILED";
export const SEARCH_COMPANIES_RESET = "SEARCH_COMPANIES_RESET";
